import { useUpdateTerminKalenderFormContext } from '@/domain/termine/features/UpdateTerminkalender/shared/UpdateTerminKalenderFormContext';
import { useTranslation } from 'react-i18next';

export function InputUpdateFormField() {
  const { t } = useTranslation();
  const form = useUpdateTerminKalenderFormContext();
  return (
    <form.AppField name="titel">
      {(field) => (
        <field.TextInput
          label={t('domain.termine.sheet.fields.titel')}
          isRequired
        />
      )}
    </form.AppField>
  );
}
